import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c2ccd4f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "test-result-modal-component" }
const _hoisted_2 = { class: "image-title-container" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-info" }, " Linha “C” não é visível: resultado inválido ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "body-info" }, " Se você realizou o autoteste e o resultado não mostra a linha “C”, ele é considerado inválido. Descarte-o e realize um novo teste. ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_modal, { ref: "base-modal" }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", { src: _ctx.errorTestCimage }, null, 8, _hoisted_3),
          _createElementVNode("img", { src: _ctx.errorTestTimage }, null, 8, _hoisted_4)
        ]),
        _hoisted_5,
        _hoisted_6
      ]),
      _: 1
    }, 512)
  ]))
}